// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageCropper_container__rWBmw","zoomSelector":"ImageCropper_zoomSelector__jv0li"};